<template> 
  <bvue-ui-view class="bg-white px-0" :scroll="true">
    <aside-user class="mx-4"/>
    <div class="menucontainer">
      <ul class="menu">
        <div class="divider section-title" :data-content=" $t('reserves') "></div>
        <li class="menu-item mx-3 flex" v-for="reserve in reserves" :key="reserve.id" @click="clicked = reserve.id; storeReserve(reserve.id);">
          <bvue-ui-router-link :to="'/map/'" active-class="active">
            <div class="w-full" v-if="$i18n.locale === 'es'">
              <div class="flex-1 titulo">{{reserve.name}}</div>
              {{reserve.partner}}
            </div>
            <div class="w-full" v-if="$i18n.locale === 'en'">
              <div class="flex-1 titulo">{{reserve.name_us}}</div>
              {{reserve.partner_us}}
            </div>
            <div class="w-full" v-if="$i18n.locale === 'de'">
              <div class="flex-1 titulo">{{reserve.name_de}}</div>
              {{reserve.partner_de}}
            </div>
            <div class="w-full" v-show="clicked === reserve.id ">
              <div class="flex mt-2">
                <div class="flex-col w-full mt-1 seedTitle">
                  {{ $t('semillas') }}
                </div>
                <div class="flex justify-end menu-badge seedBox rounded-full px-2">
                  <img class="ml-2" :src="require('@/assets/images/seed.svg')"  />
                  <label class="base-text ml-1">{{$store.getters.reserveUserSeeds(reserve.id).length}}</label>
                </div>
              </div>
            </div>
          </bvue-ui-router-link>
        </li> 
      </ul> 
      <ul class="menu">
        <div class="divider section-title" :data-content=" $t('about') "></div>
        <li class="menu-item mx-4" @click="$store.commit('setBigMap', true)" >
          <bvue-ui-router-link :to=" $t('opnq') "  active-class="active">
            <i class="fas fa-fw text-gray"></i> 
            {{ $t('quienes') }}
          </bvue-ui-router-link>
        </li>
      </ul>
      <ul class="menu last-item">
        <div class="divider section-title" :data-content=" $t('cooperantes') "></div>
        <div class="link-partner mx-4" @click="jocotoco()">
          <img class="mt-2 link-image" src="@/assets/images/jocotoco.png" alt="...">
          <center>
            {{ $t('fundacionjocotoco') }}
          </center>
        </div>
        <div class="link-partner mt-4 mx-4" @click="yakum()">
          <img class="mt-2 link-image" src="@/assets/images/yakum.png" alt="...">
          <center>
            {{ $t('fundacionyakum') }}
          </center>
        </div>
        <div class="divider section-title" :data-content=" $t('desarrolladopor') "></div>
        <div class="link-partner mt-4 mx-4" @click="redforestal()">
          <img class="mt-2 link-image" src="@/assets/images/redforestal.svg" alt="...">
          <center>
            {{ $t('fundacionredforestal') }}
          </center>
        </div>
      </ul>
    </div>
    <div class="menu-link ml-3 mb-3 mt-3">
      <bvue-ui-router-link to="/about" active-class="active" >
        <button @click="politicas()">{{ $t('politicas') }}</button> 
      </bvue-ui-router-link>
      -
      <bvue-ui-router-link to="/about" active-class="active" >
        <i class="fas fa-fw text-gray"></i> 
        <button @click="terms()">{{ $t('terminos') }}</button>
      </bvue-ui-router-link>
    </div>
    <div v-if="isAdmin" class="mt-8">
      <ul class="menu">
        <div class="divider section-title" data-content="ADMINISTRACIÓN"></div>
        <li class="menu-item mx-4">
          <bvue-ui-router-link to="/admin/countries" active-class="active">
            <i class="fas fa-fw text-gray"></i>
            {{'Países' | bvueI18n}}
          </bvue-ui-router-link>
        </li>
        <li class="menu-item mx-4">
          <bvue-ui-router-link to="/admin/species" active-class="active">
            <i class="fas fa-fw text-gray"></i>
            {{'Especies' | bvueI18n}}
          </bvue-ui-router-link>
        </li>
        <li class="menu-item mx-4">
          <bvue-ui-router-link to="/admin/ecosystems" active-class="active">
            <i class="fas fa-fw text-gray"></i>
            {{'Ecosistemas' | bvueI18n}}
          </bvue-ui-router-link>
        </li>
        <li class="menu-item mx-4">
          <bvue-ui-router-link to="/admin/reserves" active-class="active">
            <i class="fas fa-fw text-gray"></i>
            {{'Reservas' | bvueI18n}}
          </bvue-ui-router-link>
        </li>
        <li class="menu-item mx-4">
          <bvue-ui-router-link to="/admin/seriales" active-class="active">
            <i class="fas fa-fw text-gray"></i>
            {{'Seriales' | bvueI18n}}
          </bvue-ui-router-link>
        </li>
        <li class="menu-item mx-4">
          <bvue-ui-router-link to="/admin/assignseeds" active-class="active">
            <i class="fas fa-fw text-gray"></i>
            {{'Asignacion' | bvueI18n}}
          </bvue-ui-router-link>
        </li>
        <div class="divider section-title" data-content="TRANSACCIONES"></div>
        <li class="menu-item mx-4">
          <bvue-ui-router-link to="/admin/transactions" active-class="active">
            <i class="fas fa-fw text-gray"></i>
            {{'Donaciones' | bvueI18n}}
          </bvue-ui-router-link>
        </li>
      </ul>
    </div>
  </bvue-ui-view>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import AsideUser from '@/components/aside/AsideUser'
import BvueUiRouterLink from '@/components/aside/BvueUiRouterLink'

export default {
  components: {
    AsideUser,
    BvueUiRouterLink
  },
  methods: {
    storeReserve(varReserva) {
      this.$store.commit('reservaActiva', varReserva)
      this.$store.commit('setBigMap', false)
    },
    setBigMap() {
      this.$store.commit('setBigMap', true)
    },
    ...mapActions('auth', ['logout']),
    goTo (path) {
      const current = this.$route.path
      if (path !== current) {
        if (path === this.mainPath) {
          this.$router.go(-1)
        } else if(current === this.mainPath) {
          this.$router.push(path)
        } else {
          this.$router.replace(path)
        }
      }
    },
    showLanguaje() {
      console.log('presiono ingles')
    },
    terms() {   
          window.open("http://arbola.redforestal.org/terms_and_conditions_arbola.html", "_blank");    
    },
    jocotoco() {   
          window.open("https://www.jocotoco.org/wb#/ES/home", "_blank");    
    },
    yakum() {   
          window.open("https://yakum.org/", "_blank");    
    },
    redforestal() {   
      window.open("http://redforestal.org/", "_blank");    
    },
    politicas() {   
          window.open("http://arbola.redforestal.org/privacy_policy_arbola.html", "_blank");   
    }
  },
  computed: {
    ...mapState('auth', ['isAdmin']),
    ...mapGetters({reserves: 'activeReserves'}),
    ...mapGetters({uid: 'userUid'})
  },
  data () {
    return {
      mainPath: '/reserves',
      clicked: null
    }
  },
  created() {

  },
  mounted() {
    /* Colapsible Menu */
    var coll = document.getElementsByClassName("resize");
    var i;
    for (i = 0; i < coll.length; i++) {
      coll[i].addEventListener("click", function() {
        this.classList.toggle("active");
        var content = this.nextElementSibling;
        if (content.style.maxHeight){
          content.style.maxHeight = null;
        } else {
          content.style.maxHeight = content.scrollHeight + "px";
        }
      });
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@/style/_variables.scss';

.section-title {
  text-transform: uppercase;
  margin: 2rem 1rem 1rem 0.5rem;
  color: $almost-black;
  font-size: 6px !important;
  font-weight: 500;
}

.seedTitle {
  color: #614503;
}

.titulo {
  font-size: 1rem;
  color: #6D8E28;
}

.seedBox {
  background-color: $light-brown;
}

.bvue-ui-scroll {
  overflow: hidden;
}

.bvue-ui-scroll:hover {
  overflow: auto;
}

.menucontainer {
  min-height: 100%;
}

.collapsableMenu {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
}

.link-partner {
  cursor: pointer;
}

.link-image {
  max-width: 90%;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/aside/AsideMenu.vue